import { render, staticRenderFns } from "./GoogleBusinessMessagesSettingsCard.vue?vue&type=template&id=3aaa285b"
import script from "./GoogleBusinessMessagesSettingsCard.vue?vue&type=script&lang=ts"
export * from "./GoogleBusinessMessagesSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports